"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/wrapNativeSuper"));

var CramError =
/*#__PURE__*/
function (_Error) {
  (0, _inherits2.default)(CramError, _Error);

  function CramError() {
    (0, _classCallCheck2.default)(this, CramError);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CramError).apply(this, arguments));
  }

  return CramError;
}((0, _wrapNativeSuper2.default)(Error));
/** Error caused by encountering a part of the CRAM spec that has not yet been implemented */


var CramUnimplementedError =
/*#__PURE__*/
function (_Error2) {
  (0, _inherits2.default)(CramUnimplementedError, _Error2);

  function CramUnimplementedError() {
    (0, _classCallCheck2.default)(this, CramUnimplementedError);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CramUnimplementedError).apply(this, arguments));
  }

  return CramUnimplementedError;
}((0, _wrapNativeSuper2.default)(Error));
/** An error caused by malformed data.  */


var CramMalformedError =
/*#__PURE__*/
function (_CramError) {
  (0, _inherits2.default)(CramMalformedError, _CramError);

  function CramMalformedError() {
    (0, _classCallCheck2.default)(this, CramMalformedError);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CramMalformedError).apply(this, arguments));
  }

  return CramMalformedError;
}(CramError);
/**
 * An error caused by attempting to read beyond the end of the defined data.
 */


var CramBufferOverrunError =
/*#__PURE__*/
function (_CramMalformedError) {
  (0, _inherits2.default)(CramBufferOverrunError, _CramMalformedError);

  function CramBufferOverrunError() {
    (0, _classCallCheck2.default)(this, CramBufferOverrunError);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CramBufferOverrunError).apply(this, arguments));
  }

  return CramBufferOverrunError;
}(CramMalformedError);
/**
 * An error caused by data being too big, exceeding a size limit.
 */


var CramSizeLimitError =
/*#__PURE__*/
function (_CramError2) {
  (0, _inherits2.default)(CramSizeLimitError, _CramError2);

  function CramSizeLimitError() {
    (0, _classCallCheck2.default)(this, CramSizeLimitError);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CramSizeLimitError).apply(this, arguments));
  }

  return CramSizeLimitError;
}(CramError);
/**
 * An invalid argument was supplied to a cram-js method or object.
 */


var CramArgumentError =
/*#__PURE__*/
function (_CramError3) {
  (0, _inherits2.default)(CramArgumentError, _CramError3);

  function CramArgumentError() {
    (0, _classCallCheck2.default)(this, CramArgumentError);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CramArgumentError).apply(this, arguments));
  }

  return CramArgumentError;
}(CramError);

module.exports = {
  CramBufferOverrunError: CramBufferOverrunError,
  CramMalformedError: CramMalformedError,
  CramUnimplementedError: CramUnimplementedError,
  CramSizeLimitError: CramSizeLimitError,
  CramArgumentError: CramArgumentError
};